export const DocsNames = {
  links: {
    license_agreement: {
      de: 'license_agreement_de',
      en: 'license_agreement_en',
    },
    terms_and_services: {
      de: 'terms_and_services_de',
      en: 'terms_and_services_en',
    },
    king_card_insurance: {
        de: 'https://kingcard.eu/versicherung/',
        en: 'https://kingcard.eu/en/versicherung/',
    },
    terms_and_services_p24: {
      de: 'p24_terms_and_services_de',
      en: 'p24_terms_and_services_en',
    },
    license_agreement_p24: {
      de: 'p24_license_agreement_de',
      en: 'p24_license_agreement_en',
    },
    terms_and_services_total: {
      de: 'total_terms_and_services_de',
      en: 'total_terms_and_services_en',
    },
    cashback_conditions: {
      de: 'cashback_conditions_de',
      en: 'cashback_conditions_en',
    },
  },
  labels: {
    license_agreement: 'ORDER.FULL_NAME.FORM.CHECKBOXES.PRIVACY_POLICY',
    terms_and_services: 'ORDER.FULL_NAME.FORM.CHECKBOXES.TERMS_AND_CONDITIONS',
    king_card_insurance: 'ORDER.PRODUCT.HEPSTER_CHOOSE_2_link',
    cashback_conditions: 'ORDER.FULL_NAME.FORM.CHECKBOXES.CASHBACK_CONDITIONS',
  }
};

export enum TemplatesNames {
    license_agreement_de = 'PRIVACY POLICY (de)',
    license_agreement_en = 'PRIVACY POLICY (en)',
    terms_and_services_de = 'TERMS AND CONDITIONS (de)',
    terms_and_services_en = 'TERMS AND CONDITIONS (en)',
    p24_terms_and_services_de = 'P24 - TERMS AND CONDITIONS (de)',
    p24_terms_and_services_en = 'P24 - TERMS AND CONDITIONS (en)',
    p24_license_agreement_de = 'P24 - PRIVACY POLICY (de)',
    p24_license_agreement_en = 'P24 - PRIVACY POLICY (en)',
    total_terms_and_services_de = 'TOTAL - TERMS AND CONDITIONS (de)',
    total_terms_and_services_en = 'TOTAL - TERMS AND CONDITIONS (en)',
    cashback_conditions_de = 'Cashback Conditions (de)',
    cashback_conditions_en = 'Cashback Conditions (en)',

    cancellation_confirmation_de = 'CardBro Cancellation Confirmation Text (de)',
    cancellation_confirmation_en = 'CardBro Cancellation Confirmation Text (en)'
}
